import React, { useEffect, useState } from 'react'
import { Button, Col, Collapse, Menu, Row } from 'antd';

import { openNotification } from '@seims/shared';
import { Messages, Notify } from '../../../services/custom/Messages';
import util from "../../../utils/functions/custom";

import { recordError } from "../../../utils/logService";

import { Link, useParams } from 'react-router-dom';

import service from '../../../services/citizenscienceService';
import lookupApi from "../../../services/partnershipLookupService";

import ProjectLead from './ProjectLead';
import ProjectDetails from './ProjectDetails';
import TargetBeneficiaries from './TargetBeneficiaries';
import ProjectObjectives from './ProjectObjectives';
import ProjectParticipants from './ProjectParticipants';
import ProjectPartners from './ProjectPartners';
import ParticipantsRoles from './ParticipantsRoles';

const { Panel } = Collapse;

export default function ViewProjectDetails() {
    let msg = "";
    var action = "Update Project";
    const [projectLeadInfo, setProjectLeadInfo] = useState({});
    const [projectDetails, setProjectDetails] = useState({});
    const [projectObjectives, setProjectObjectives] = useState({});
    const [targetBeneficiaries, setTargetBeneficiaries] = useState({});

    const [projectPartners, setProjectPartners] = useState([]);
    const [projectParticipants, setProjectParticipants] = useState({});
    const [projectParticipantRoles, setProjectParticipantRoles] = useState({});
    const [partners, setPartners] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState("0");
    const [projectId, setProjectId] = useState();
    const [projectUuid, setProjectUuid] = useState();
    const [lastUpdate, setLastUpdate] = useState(false);
    const [contributions, setContributions] = useState([]);
    const [projectProfile, setProjectProfile] = useState([]);
    const [acceptingParticipants, setAcceptingParticipants] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(false);

    useEffect(() => {
        setSelectedMenu('projectLead')
        prePopulate();
        getContributions();
    }, [projectUuid, hasUpdated==true]);

    const { key } = useParams();

    const menuItems = [

        {
            key: "projOverview",
            label: "Project Overview",
            children:
                [
                    {
                        key: "projectLead",
                        label: "Project Lead"
                    },
                    {
                        key: "projectDetails",
                        label: "Project Details"
                    },
                    {
                        key: "objectives",
                        label: "Objectives"
                    },
                    {
                        key: "targetBen",
                        label: "Target Beneficiaries"
                    },
                ],
        },
        {
            key: "participantsRoles",
            label: "Citizen Scientist Roles"
        },
        {
            key: "citizenScientists",
            label: "Citizen Scientists"
        },
        {
            key: "partners",
            label: "Partnerships"
        },
    ];

    const prePopulate = async () => {
      try {
        const params = key.split("&");
        if (key !== undefined) {
          setProjectId(params[0]);
          setProjectUuid(params[1]);
          const response = await service.getProjectDetails(params[0]);
          if (response && response.status === 200) {
            const { data } = response;
            createProjectProfile(data);
          }
        }
      } catch (error) {
        msg = util.parseMessage(Messages.GET_FAILURE);
        openNotification("Project details", msg, Notify.ERROR);
        console.log("Error ", error);
        recordError(error);
      }
    };

    const getContributions = async () => {
      try {
        const response = await lookupApi.getContributions();
        if (response) {
          const { data } = response;
          const transformData = data.map((c) => ({
            label: c.value,
            value: c.key.toString(),
            key: c.key,
          }));

          setContributions(transformData);
        }
      } catch (error) {
        recordError(error);
      }
    };

    const onMenuChange = (menu) => {
      setSelectedMenu(menu.key);
      if (menu.key === "partners") {
        setLastUpdate(true);
      } else {
        setLastUpdate(false);
      }
    };

    const createProjectProfile = (data) => {
      let domains = [];
      let objectives = [];
      let disseminations = [];
      let locations = [];
      let beneficiaries = [];
      let rolesPreProject = [];
      let rolesDuringProject = [];
      let rolesPostProject = [];
      let contributionRecognitions = [];
      let projectPartners = [];
      var statusColor = "";

      if (!data) return;

      switch (data.status) {
        case "Submitted":
          statusColor = "#2E86C1";
          break;
        case "In Review":
          statusColor = "#F39C12";
          break;
        case "Approved":
          statusColor = "#2ECC71";
          break;
        case "Rejected":
          statusColor = "#C0392B";
          break;
        case "Closed":
          statusColor = "#6E2C00";
          break;
        default:
          statusColor = "";
      }

      data.scienceDomains?.forEach((domain) => {
        domains.push(domain.key);
      });

      data.objectives?.forEach((objective) => {
        objectives.push(objective.key);
      });

      data.dissemination?.forEach((disseminate) => {
        disseminations.push(disseminate.key);
      });

      data.rolesDuringProject?.forEach((during) => {
        rolesDuringProject.push(during.key);
      });

      data.rolesPostProject?.forEach((post) => {
        rolesPostProject.push(post.key);
      });

      data.rolesPreProject?.forEach((pre) => {
        rolesPreProject.push(pre.key);
      });

      data.contributionRecognition?.forEach((post) => {
        contributionRecognitions.push(post.key);
      });

      if (data.beneficiaries?.length > 0) {
        const tbeneficiaries = data.beneficiaries;
        let impact = [];
        let benData = "";
        tbeneficiaries.forEach((beneficiary) => {
          beneficiary?.impact?.forEach((ben) => {
            impact.push(ben.key);
          });
          benData = {
            type: beneficiary.key,
            impact: impact,
          };
          impact = [];
          beneficiaries.push(benData);
        });
      }

      if (data.organisations.length > 0) {
        const tpartners = data.organisations;
        let contrib = [];
        let partnerData = "";
        tpartners.forEach((partner) => {
          if (partner.contributions !== undefined) {
            partner.contributions.forEach((contribution) => {
              contrib.push(contribution.key);
            });
            partnerData = {
              id: partner.id,
              contributions: contrib,
            };
            contrib = [];
            projectPartners.push(partnerData);
          }
        });
      }

      if (data.locations.length > 0) {
        const loc = data.locations;
        let locData = "";
        loc.forEach((location) => {
          locData = {
            town: location?.town?.key,
            district: location.district.key,
            province: location.province.key,
          };
          locations.push(locData);
          locData = "";
        });
      }

      const project = {
        projectLead: {
          title: data.projectLead.title.key,
          contactNumber: data.projectLead.contactNumber,
          firstname: data.projectLead.firstName,
          lastname: data.projectLead.lastname,
          email: data.projectLead.email,
        },
        name: data.name,
        description: data.description,
        scienceField: data.scienceField.key,
        scienceDomains: domains,
        initiallyCitizenScience: data.initiallyCitizenScience,
        objectives: objectives,
        otherObjectives:
          data.otherObjectives === undefined ? null : data.otherObjectives,
        dissemination: disseminations,
        otherDissemination:
          data.otherDissemination === undefined
            ? null
            : data.otherDissemination,
        startDate: data.startDate,
        endDate: data.endDate,
        locations: locations,
        lastModified: new Date(),
        rolesPreProject: rolesPreProject,
        rolesDuringProject: rolesDuringProject,
        otherDuringRole:
          data.otherDuringRole === undefined ? null : data.otherDuringRole,
        rolesPostProject: rolesPostProject,
        otherPostRole:
          data.otherPostRole === undefined ? null : data.otherPostRole,
        contributionRecognition: contributionRecognitions,
        otherRecognition:
          data.otherRecognition === undefined ? null : data.otherRecognition,
        organisationContributions: projectPartners,
        beneficiaries: beneficiaries,
        otherBeneficiary:
          data.otherBeneficiary === undefined ? null : data.otherBeneficiary,
        scienceShopInitiative: data.scienceShopInitiative,
      };
      setProjectProfile(project);

      const proj = {
        status: data.status,
        statusColor: statusColor,
        titleName: data.projectLead.title.value,
        titleId: data.projectLead.title.key,
        projectProfile: project,
        name: data.name,
        id: projectId,
      };
      setProjectLeadInfo(proj);

      const projDetails = {
        disseminations: data.dissemination,
        locations: data.locations,
        id: projectId,
        statusColor: statusColor,
        projectProfile: project,
        address: data.locations,
        scienceFields: data.scienceField,
        scienceDomains: data.scienceDomains,
        status: data.status,
      };
      setProjectDetails(projDetails);
      const targetBeneficiaries = {
        name: data.name,
        status: data.status,
        beneficiaries: data.beneficiaries,
        projectProfile: project,
        statusColor: statusColor,
        id: projectId,
      };
      setTargetBeneficiaries(targetBeneficiaries);

      const projectObj = {
        name: data.name,
        status: data.status,
        objectives: data.objectives,
        otherObjectives: data.otherObjectives,
        projectProfile: project,
        statusColor: statusColor,
        id: projectId,
      };
      setProjectObjectives(projectObj);

      const participantRoles = {
        rolesDuringProject: data.rolesDuringProject,
        rolesPreProject: data.rolesPreProject ?? [],
        otherDuringRole: data.otherDuringRole,
        rolesPostProject: data.rolesPostProject,
        otherPostRole: data.otherPostRole,
        contributionRecognition: data.contributionRecognition,
        otherRecognition: data.otherRecognition,
        projectName: data.name,
        status: data.status,
        projectProfile: project,
        statusColor: statusColor,
        id: projectId,
      };
      setProjectParticipantRoles(participantRoles);

      setAcceptingParticipants(data.acceptingParticipants);
      const participants = {
        name: data.name,
        status: data.status,
        participants:
          data.organisations === undefined ? [] : data.organisations,
        projectuuid: projectUuid,
        projectid: projectId,
        roles: data.roles,
        projectProfile: project,
        statusColor: statusColor,
        acceptingParticipants: acceptingParticipants,
        rolesDuringProject: data.rolesDuringProject,
        rolesPreProject: data.rolesPreProject ?? [],
        otherDuringRole: data.otherDuringRole,
        rolesPostProject: data.rolesPostProject,
      };

      setProjectParticipants(participants);

      const partners = {
        partners: data.organisations,
        name: data.name,
        status: data.status,
        statusColor: statusColor,
        projectProfile: project,
        id: projectId,
      };
      setProjectPartners(partners);
    };


    return (
        <>
            <div className='project-overview view-project'>
                <Row className=''>
                    <Col xs={6} className='project-navigation'>
                        <Collapse defaultActiveKey={['projectOverview']} >
                            <Panel key="projectOverview">
                                <Menu
                                    items={menuItems}
                                    mode="inline"
                                    onClick={onMenuChange}
                                    onSelect={onMenuChange}
                                    defaultOpenKeys={['projOverview']}
                                    defaultSelectedKeys={['projectLead']}
                                />
                            </Panel>
                        </Collapse>
                    </Col>
                    <Col xs={18} className="project-details-right">
                        {selectedMenu === "projectLead" && (
                            <ProjectLead data={projectLeadInfo} />
                        )}
                        {selectedMenu === "projectDetails" && (

                            <ProjectDetails data={projectDetails} />
                        )}
                        {selectedMenu === "objectives" && (
                            <ProjectObjectives data={projectObjectives} />
                        )}
                        {selectedMenu === "targetBen" && (
                            <TargetBeneficiaries data={targetBeneficiaries} />
                        )}
                        {selectedMenu === "participantsRoles" && (
                            <ParticipantsRoles data={projectParticipantRoles} />
                        )}
                        {selectedMenu === "citizenScientists" && (
                            <ProjectParticipants 
                            data={projectParticipants} 
                            setAcceptingParticipants={setAcceptingParticipants} 
                            acceptingParticipants={acceptingParticipants}
                            />
                        )}

                        {selectedMenu === "partners" && (
                            <ProjectPartners data={projectPartners} />

                        )}

                    </Col>
                </Row>
            </div>
            <div>
                <Col xs={21}>
                    <Link key="my-projects" to="/my-projects">
                        <Button style={{ marginLeft: "50px", marginBottom: "20px" }} className="right-align-button add-button" type="primary" shape="round"
                        >
                            Back to List of Projects
                        </Button>
                    </Link>
                </Col>
            </div>
        </>
    );

}
